import { Component, OnInit } from '@angular/core';
import { generalService } from '../services/general.service';

@Component({
  selector: 'app-corte-caja',
  templateUrl: './corte-caja.component.html',
  styleUrls: ['./corte-caja.component.scss'],
  providers: [generalService]
})
export class CorteCajaComponent implements OnInit {

  public idHistorialCorte = null
  public mostrarRealizarCorte: boolean = true;
  constructor(private _generalService: generalService) { }

  ngOnInit() {
  }

  toggleTab() {
    this.mostrarRealizarCorte = !this.mostrarRealizarCorte;
    this.idHistorialCorte = null;
  }

  consultarDetalleHistorico(idHistorialCorte: number) {
    this.idHistorialCorte = idHistorialCorte;
    this.mostrarRealizarCorte = true;
  }

}



// WEBPACK FOOTER //
// ./src/app/corte-caja/corte-caja.component.ts